import { render } from "./Tecajevi.vue?vue&type=template&id=ff1cf8b6"
import script from "./Tecajevi.vue?vue&type=script&lang=js"
export * from "./Tecajevi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__